import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { FileText, ShoppingBag, ClipboardCheck, ClipboardList, PackageCheck, FilePlus2, Inbox } from "lucide-react";

const TONES = {
  orange:  "bg-orange-500/10  text-orange-600  border-orange-500/25",
  amber:   "bg-amber-500/10   text-amber-600   border-amber-500/25",
  blue:    "bg-blue-500/10    text-blue-600    border-blue-500/25",
  purple:  "bg-purple-500/10  text-purple-600  border-purple-500/25",
  emerald: "bg-emerald-500/10 text-emerald-600 border-emerald-500/25",
  slate:   "bg-slate-500/10   text-slate-600   border-slate-500/25",
};
const ICONS = {
  open_po:    ShoppingBag,   partial_po: ShoppingBag,
  open_grn:   PackageCheck,
  open_pr:    ClipboardList, partial_pr: ClipboardList,
  open_so:    ClipboardCheck,
  draft_inv:  FilePlus2,
};

/**
 * Open Docs — Six-card dashboard tile showing every open workflow doc that
 * needs attention (Open PO/PR/GRN/SO + Partial PO/PR + Draft invoices).
 * Backend: GET /api/open-docs/summary.
 */
export default function OpenDocsWidget() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/open-docs/summary").then(r => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data) return null;
  const anyOpen = data.cards.some(c => c.count > 0);
  if (!anyOpen) return null;
  return (
    <Card className="rounded-sm border p-4 md:p-5" data-testid="open-docs-widget">
      <div className="flex items-center gap-2 mb-3">
        <Inbox className="w-4 h-4 text-accent" />
        <div className="text-[10px] font-mono uppercase tracking-widest text-accent">// Open workflow docs</div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2.5">
        {data.cards.map(c => {
          const Icon = ICONS[c.key] || FileText;
          const disabled = !c.count;
          return (
            <Link key={c.key} to={c.url}
                    className={`rounded-sm border p-3 transition-all ${disabled ? "opacity-40 pointer-events-none" : "hover:brightness-95"} ${TONES[c.tone] || TONES.slate}`}
                    data-testid={`open-doc-${c.key}`}>
              <div className="flex items-center justify-between">
                <Icon className="w-4 h-4 opacity-80" />
                <span className="text-2xl font-bold tabular-nums">{c.count}</span>
              </div>
              <div className="text-[10px] font-mono uppercase mt-1 leading-tight">{c.label}</div>
            </Link>
          );
        })}
      </div>
    </Card>
  );
}
